import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import * as RoutesModule from './routes';
import { navigationStore } from './Stores/NavigationStore';
import { permissionStore } from './Stores/PermissionStore';
import ErrorBoundary from './Components/ErrorBoundary';
import { requestTimelineService } from './Services/RequestTimelineService';
import { NotificationContainer } from './Components/ToastNotification';
import { ToolTipContainer } from './Components/ToolTipItem';
import { Modals } from "./Components/Modal";
import { stationsStore } from './Stores/StationsStore';

const routes = RoutesModule.routes;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;

const DATA_COMPLETENESS_DELAY_MS = 3000;

type AppProps = {
    callback: () => void;
};

export default class App extends React.Component<AppProps> {
    private _dataCompletenessTimer?: number;

    componentDidMount() {
        this.props.callback();
        requestTimelineService.init();
        navigationStore.init();
        permissionStore.init();

        // Fetch the data-completeness badge counts 3s after load, silently and without blocking page render.
        this._dataCompletenessTimer = window.setTimeout(() => {
            void stationsStore.loadStationsDataCompleteness();
        }, DATA_COMPLETENESS_DELAY_MS);
    }

    componentWillUnmount() {
        if (this._dataCompletenessTimer) {
            window.clearTimeout(this._dataCompletenessTimer);
        }
    }

    render() {
        return (
            <ErrorBoundary>
                <Provider>
                    <BrowserRouter basename={baseUrl}>
                        {routes}
                    </BrowserRouter>
                </Provider>
                <NotificationContainer />
                <ToolTipContainer />
                <Modals />
            </ErrorBoundary>
        );
    }
}
